<div *ngIf="(raceRanking$ | async) as raceRanking">
  <mc-race-ranking-standings [raceRanking]="raceRanking"></mc-race-ranking-standings>
</div>
